import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import Pagination from "../../extra/Pagination";
import defaultImage from "../../../assets/images/default.jpg";
import { getRewardTransactions } from "../../store/rewardWallet/rewardWallet.action";

const typeBadge = (type) => {
  switch (type) {
    case "earn": return { label: "Earn", color: "#10B981", bg: "#D1FAE5" };
    case "spend": return { label: "Spend", color: "#EF4444", bg: "#FEE2E2" };
    case "refund": return { label: "Refund", color: "#3B82F6", bg: "#DBEAFE" };
    case "expiry": return { label: "Expiry", color: "#F59E0B", bg: "#FEF3C7" };
    case "adjustment": return { label: "Adjustment", color: "#8B5CF6", bg: "#F3E8FF" };
    default: return { label: type || "—", color: "#6B7280", bg: "#F3F4F6" };
  }
};

const sourceLabel = (src) => {
  const map = {
    signup: "Signup Bonus",
    ad_view: "Ad View",
    video_watch: "Video Watch",
    product_share: "Product Share",
    first_purchase_bonus: "First Purchase",
    referral_first_purchase: "Referral (first purchase)",
    order_redemption: "Order Redemption",
    order_refund: "Order Refund",
    admin_credit: "Admin Credit",
    admin_debit: "Admin Debit",
    expiry: "Expiry",
    velocity_flag: "Velocity Flag",
    reconciler_flag: "Reconciler Flag",
  };
  return map[src] || src || "—";
};

const RewardTransactions = () => {
  const dispatch = useDispatch();
  const { transactions, txnPagination, txnStats } = useSelector((s) => s.rewardWallet);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [type, setType] = useState("all");
  const [source, setSource] = useState("all");
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  useEffect(() => {
    dispatch(getRewardTransactions(page, limit, type, source, search, startDate, endDate));
  }, [dispatch, page, limit, type, source, startDate, endDate]);

  const handleSearch = () => {
    setPage(1);
    dispatch(getRewardTransactions(1, limit, type, source, search, startDate, endDate));
  };

  const handleApply = (_, picker) => {
    setStartDate(dayjs(picker.startDate).format("YYYY-MM-DD"));
    setEndDate(dayjs(picker.endDate).format("YYYY-MM-DD"));
    setPage(1);
  };
  const handleCancel = (_, picker) => {
    picker.element.val("");
    setStartDate("All");
    setEndDate("All");
    setPage(1);
  };

  return (
    <div className="mainSellerTable">
      <div className="sellerTable">
        <div className="col-12 headname">Coin Transaction Ledger</div>

        {/* Stats */}
        <div className="row mx-2 mb-3">
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #EBF5FF)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Entries (filtered)</p>
              <h3 className="mb-0" style={{ color: "#1F2937", fontWeight: "600" }}>{txnStats?.totalCount || 0}</h3>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #D1FAE5)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Total Earned</p>
              <h3 className="mb-0" style={{ color: "#10B981", fontWeight: "600" }}>+{txnStats?.totalEarn || 0}</h3>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #FEE2E2)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Total Spent</p>
              <h3 className="mb-0" style={{ color: "#EF4444", fontWeight: "600" }}>{txnStats?.totalSpend || 0}</h3>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #FEF3C7)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Expired</p>
              <h3 className="mb-0" style={{ color: "#F59E0B", fontWeight: "600" }}>{txnStats?.totalExpiry || 0}</h3>
            </div>
          </div>
        </div>

        <div className="sellerMain">
          <div className="tableMain">
            <div className="sellerHeader primeHeader">
              <div className="row align-items-center">
                <div className="col-xl-2 col-md-3 col-6 mb-2">
                  <select
                    className="form-select"
                    value={type}
                    onChange={(e) => { setType(e.target.value); setPage(1); }}
                    style={{ borderRadius: "5px", padding: "8px" }}
                  >
                    <option value="all">All Types</option>
                    <option value="earn">Earn</option>
                    <option value="spend">Spend</option>
                    <option value="refund">Refund</option>
                    <option value="expiry">Expiry</option>
                    <option value="adjustment">Adjustment</option>
                  </select>
                </div>

                <div className="col-xl-2 col-md-3 col-6 mb-2">
                  <select
                    className="form-select"
                    value={source}
                    onChange={(e) => { setSource(e.target.value); setPage(1); }}
                    style={{ borderRadius: "5px", padding: "8px" }}
                  >
                    <option value="all">All Sources</option>
                    <option value="signup">Signup Bonus</option>
                    <option value="ad_view">Ad View</option>
                    <option value="video_watch">Video Watch</option>
                    <option value="product_share">Product Share</option>
                    <option value="first_purchase_bonus">First Purchase</option>
                    <option value="referral_first_purchase">Referral (first purchase)</option>
                    <option value="order_redemption">Order Redemption</option>
                    <option value="order_refund">Order Refund</option>
                    <option value="admin_credit">Admin Credit</option>
                    <option value="admin_debit">Admin Debit</option>
                    <option value="expiry">Expiry</option>
                    <option value="velocity_flag">Velocity Flag</option>
                  </select>
                </div>

                <div className="col-xl-3 col-md-3 col-6 mb-2">
                  <DateRangePicker
                    initialSettings={{
                      autoUpdateInput: false,
                      locale: { cancelLabel: "Clear" },
                      maxDate: new Date(),
                    }}
                    onApply={handleApply}
                    onCancel={handleCancel}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Select Date Range"
                      readOnly
                      style={{ cursor: "pointer", padding: "8px" }}
                    />
                  </DateRangePicker>
                </div>

                <div className="col-xl-5 col-md-3 col-12 mb-2">
                  <div className="d-flex">
                    <input
                      type="text"
                      className="form-control me-2"
                      placeholder="Search user (name, email, phone, uniqueId)"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                      style={{ padding: "8px" }}
                    />
                    <button
                      className="btn"
                      onClick={handleSearch}
                      style={{ background: "#B93160", color: "#fff", padding: "8px 20px" }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="primeMain">
              <table width="100%" className="primeTable text-center" style={{ maxHeight: "600px" }}>
                <thead className="sticky-top" style={{ top: "-1px", zIndex: "1" }}>
                  <tr>
                    <th className="fw-bold py-3">No</th>
                    <th className="fw-bold py-3">Date & Time</th>
                    <th className="fw-bold py-3">User</th>
                    <th className="fw-bold py-3">Type</th>
                    <th className="fw-bold py-3">Source</th>
                    <th className="fw-bold py-3">Amount</th>
                    <th className="fw-bold py-3">Balance After</th>
                    <th className="fw-bold py-3">Reference</th>
                    <th className="fw-bold py-3">Idempotency Key</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions?.length > 0 ? (
                    transactions.map((t, idx) => {
                      const tb = typeBadge(t.type);
                      const u = t.user;
                      const name = u?.fullName || [u?.firstName, u?.lastName].filter(Boolean).join(" ") || "—";
                      const signed = t.amount > 0 ? `+${t.amount}` : String(t.amount);
                      const amountColor = t.amount > 0 ? "#10B981" : t.amount < 0 ? "#EF4444" : "#9CA3AF";
                      return (
                        <tr key={t._id}>
                          <td className="text-white py-3">{(page - 1) * limit + idx + 1}</td>
                          <td className="text-white py-3">
                            <small>
                              {dayjs(t.createdAt).format("DD MMM 'YY")}<br />
                              <span style={{ color: "#9CA3AF" }}>{dayjs(t.createdAt).format("HH:mm:ss")}</span>
                            </small>
                          </td>
                          <td className="text-white py-3">
                            <div className="d-flex align-items-center justify-content-center">
                              <img
                                src={u?.image || defaultImage}
                                width={28}
                                height={28}
                                style={{ borderRadius: "50%", marginRight: "8px", objectFit: "cover" }}
                                alt=""
                                onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
                              />
                              <div className="text-start">
                                <div style={{ fontSize: 13 }}>{name}</div>
                                <small style={{ color: "#9CA3AF" }}>{u?.uniqueId || String(t.userId).slice(-8)}</small>
                              </div>
                            </div>
                          </td>
                          <td className="py-3">
                            <span
                              className="px-3 py-1"
                              style={{
                                backgroundColor: tb.bg,
                                color: tb.color,
                                borderRadius: "20px",
                                fontSize: "12px",
                                fontWeight: 500,
                              }}
                            >
                              {tb.label}
                            </span>
                          </td>
                          <td className="text-white py-3">
                            <small>{sourceLabel(t.source)}</small>
                          </td>
                          <td className="py-3">
                            <span style={{ fontWeight: 600, color: amountColor }}>{signed}</span>
                          </td>
                          <td className="text-white py-3">{t.balanceAfter}</td>
                          <td className="text-white py-3">
                            {t.referenceType && t.referenceId ? (
                              <small>
                                {t.referenceType}
                                <br />
                                <span style={{ color: "#9CA3AF" }}>{String(t.referenceId).slice(-8)}</span>
                              </small>
                            ) : (
                              <small style={{ color: "#9CA3AF" }}>—</small>
                            )}
                          </td>
                          <td className="text-white py-3">
                            <small
                              title={t.idempotencyKey}
                              style={{ color: "#9CA3AF", fontFamily: "monospace" }}
                            >
                              {(t.idempotencyKey || "").length > 28
                                ? t.idempotencyKey.slice(0, 25) + "..."
                                : t.idempotencyKey}
                            </small>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center text-white py-5">
                        No transactions found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <Pagination
              component="div"
              count={txnPagination?.total || 0}
              totalData={txnPagination?.total || 0}
              type={"server"}
              onPageChange={(e, newPage) => setPage(newPage)}
              serverPerPage={limit}
              serverPage={page}
              setCurrentPage={setPage}
              onRowsPerPageChange={(v) => { setLimit(parseInt(v, 10)); setPage(1); }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { getRewardTransactions })(RewardTransactions);
